import styles from './LoadingOverlay.module.css';

type LoadingOverlayProps = {
  message?: string;
  /** true でビューポート基準 (position: fixed) にする。デフォルトは祖先要素基準 (position: absolute) */
  fullScreen?: boolean;
  /** true で半透明の暗幕を付けず、背景を塗らない (下地を黒で覆いたくない箇所向け) */
  transparent?: boolean;
};

export function LoadingOverlay({ message = '読み込み中...', fullScreen = false, transparent = false }: LoadingOverlayProps) {
  const base = fullScreen ? styles.overlayFixed : styles.overlay;
  return (
    <div className={transparent ? `${base} ${styles.transparent}` : base}>
      <div className={styles.spinner} />
      <p>{message}</p>
    </div>
  );
}
